import {
	isValidName,
	email,
	isValidPanCard,
	aadharValidator,
	passportValidator,
	validPhone
} from 'UtilityComponents/Util';

const validEmail = (value) => !email(value);

const validName = (value) => !isValidName(value);

const validPan = (value) => !isValidPanCard(value);

const validAadhar = (value) => aadharValidator(value);

const validPassport = (value) => passportValidator(value);

export const bookingSteps = [
	{
		id: 1,
		value: 'Fill the booking form to request for train tickets.'
	},
	{
		id: 2,
		value: 'Wait for myBiz team to finalise the booking for you.'
	},
	{
		id: 2,
		value: 'Get the confirmed train tickets on your registered email id.'
	}
];

export const trainDetails = [
	{
		trainNoLabel: {
			inputType: 'label',
			placeHolder: 'Train No. & Name'
		},
		xs: 12,
		lg: 12,
		marginBottom: 0
	},
	{
		trainNoInput: {
			inputType: 'text',
			placeHolder: 'Enter Train No.',
			inputClass: 'greyTheme',
			value: '',
			name: 'trainNo',
			errorOnBlur: true,
			nocHangeError: true,
			isMandatory: true,
			outLabel: true,
			fSize: '22px'
		},
		width: '33%',
		xs: 12,
		lg: 4
	},
	{
		trainNameInput: {
			inputType: 'text',
			placeHolder: 'Enter Train Name',
			inputClass: 'greyTheme',
			value: '',
			name: 'trainName',
			errorOnBlur: true,
			nocHangeError: true,
			isMandatory: true,
			outLabel: true,
			fSize: '22px'
		},
		width: '63%',
		xs: 12,
		lg: 8
	}
];

export const cityDetails = [
	{
		fromLabel: {
			inputType: 'label',
			placeHolder: 'Going From',
			isMandatory: true,
			marginBottom: 16
		},
		fromInput: {
			inputType: 'text',
			placeHolder: 'City From',
			inputClass: 'greyTheme',
			value: '',
			name: 'fromCity',
			validation: {
				required: {
					msg: 'Required!'
				}
			},
			errorOnBlur: true,
			nocHangeError: true,
			isMandatory: true,
			outLabel: true,
			fSize: '22px'
		},
		width: '45%',
		justify: 'flex-start',
		xs: 12,
		lg: 5
	},
	{
		doubleArrow: {
			inputType: 'icon',
			icon: 'doubleArrow'
		},
		width: '10%',
		xs: false,
		lg: 1,
		hideMobile: true,
		itemClass: 'doubleArrw--item'
	},
	{
		toLabel: {
			inputType: 'label',
			placeHolder: 'Going To',
			isMandatory: true
		},
		toInput: {
			inputType: 'text',
			placeHolder: 'City To',
			inputClass: 'greyTheme',
			value: '',
			name: 'toCity',
			validation: {
				required: {
					msg: 'Required!'
				}
			},
			errorOnBlur: true,
			nocHangeError: true,
			isMandatory: true,
			outLabel: true,
			fSize: '22px'
		},
		width: '45%',
		justify: 'flex-start',
		xs: 12,
		lg: 5
	}
];

export const boardingDetails = [
	{
		boardingLabel: {
			inputType: 'label',
			placeHolder: 'Your Boarding Station',
			isMandatory: true
		},
		boardingInput: {
			inputType: 'text',
			placeHolder: 'Enter Boarding Station',
			inputClass: 'greyTheme',
			value: '',
			name: 'boardingStation',
			validation: {
				required: {
					msg: 'Required!'
				}
			},
			errorOnBlur: true,
			nocHangeError: true,
			isMandatory: true,
			outLabel: true,
			fSize: '22px'
		},
		xs: 12,
		width: '100%'
	}
];

export const travelDate = [
	{
		datelabel: {
			inputType: 'label',
			placeHolder: 'Travel Date',
			isMandatory: true
		},
		dateInput: {
			inputType: 'calender',
			value: '',
			name: 'travelDate',
			placeholder: 'Date',
			validation: {
				required: {
					msg: 'Required!'
				}
			},
			errorOnBlur: true,
			nocHangeError: true,
			isMandatory: true,
			outLabel: true
		},
		width: '100%',
		xs: 12
	}
];

export const reservationType = [
	{
		reservationLabel: {
			inputType: 'label',
			placeHolder: 'Reservation Type',
			isMandatory: true
		},
		reservationInput: {
			inputType: 'dropDown',
			placeholder: 'Reservation',
			options: [
				{
					label: 'General',
					value: 'General'
				},
				{
					label: 'Ladies',
					value: 'Ladies'
				},
				{
					label: 'Lower Berth/ Sr. Citizen',
					value: 'Lower Berth/ Sr. Citizen'
				},
				{
					label: 'Divyaang',
					value: 'Divyaang'
				},
				{
					label: 'Tatkal',
					value: 'Tatkal'
				},
				{
					label: 'Premium Tatkal',
					value: 'Premium Tatkal'
				}
			],
			name: 'reservationType',
			value: '',
			validation: {
				required: {
					msg: 'Required!'
				}
			},
			isOpenTop: true,
			isMandatory: true,
			outLabel: true,
			errorOnBlur: true
		},
		width: '100%',
		xs: 12
	}
];

export const classType = [
	{
		classLabel: {
			inputType: 'label',
			placeHolder: 'Class',
			isMandatory: true
		},
		classInput: {
			inputType: 'dropDown',
			placeholder: 'Class',
			options: [
				{
					label: 'All Class',
					value: 'All Class'
				},
				{
					label: 'Sleeper Class',
					value: 'Sleeper Class'
				},
				{
					label: 'Third AC',
					value: 'Third AC'
				},
				{
					label: 'Second AC',
					value: 'Second AC'
				},
				{
					label: 'First AC',
					value: 'First AC'
				},
				{
					label: 'Second Sitting',
					value: 'Second Sitting'
				},
				{
					label: 'AC Chair Car',
					value: 'AC Chair Car'
				}
			],
			name: 'classType',
			value: '',
			validation: {
				required: {
					msg: 'Required!'
				}
			},
			isOpenTop: true,
			isMandatory: true,
			outLabel: true,
			errorOnBlur: true
		},
		width: '100%',
		xs: 12
	}
];

export const preferences = [
	travelDate,
	reservationType,
	classType
];

export const travellerForm1 = [
	{
		required: true,
		name: 'emailId',
		label: 'Work Email Id',
		inputClass: 'greyTheme',
		type: 'email',
		validation: {
			required: {
				msg: 'Required!'
			},
			custom: {
				validator: validEmail,
				msg: 'Enter Valid Email'
			}
		},
		errorOnBlur: true,
		nocHangeError: true,
		isMandatory: true,
		outLabel: true,
		inputHeight: '55px',
		xs: 12,
		lg: 12
	},
	{
		name: 'name',
		label: 'Full Name',
		required: true,
		inputClass: 'greyTheme',
		value: '',
		nocHangeError: true,
		errorOnBlur: true,
		validation: {
			required: {
				msg: 'Required!'
			},
			custom: {
				validator: validName,
				msg: 'Not a valid Name'
			}
		},
		type: 'text',
		isMandatory: true,
		outLabel: true,
		inputHeight: '55px',
		xs: 12,
		lg: 12
	},
	{
		name: 'phone',
		label: 'Phone Number',
		inputClass: 'greyTheme',
		value: '',
		isMandatory: true,
		required: true,
		errorOnBlur: false,
		maxLen: '10',
		validation: {
			custom: {
				validator: validPhone,
				msg: 'Not a valid Phone Number'
			}
		},
		type: 'tel',
		outLabel: true,
		inputHeight: '55px',
		xs: 12,
		lg: 12
	},
	[
		{
			name: 'age',
			label: 'Age',
			inputClass: 'greyTheme',
			required: true,
			value: '',
			maxLen: '3',
			validation: {
				required: {
					msg: 'Required!'
				}
			},
			type: 'number',
			nocHangeError: true,
			isMandatory: true,
			outLabel: true,
			errorOnBlur: true,
			inputHeight: '55px',
			xs: 5,
			lg: 3
		},
		{
			name: 'gender',
			label: 'Gender',
			required: true,
			validation: {
				required: {
					msg: 'Required!'
				}
			},
			options: [
				{
					name: 'Male',
					description: 'Male',
					id: 1
				},
				{
					name: 'Female',
					description: 'Female',
					id: 2
				}
			],
			isOpenTop: true,
			type: 'select',
			isMandatory: true,
			outLabel: true,
			errorOnBlur: true,
			xs: 7,
			lg: 4
		},
		{
			name: 'nationality',
			label: 'Nationality',
			inputClass: 'greyTheme',
			required: true,
			value: '',
			maxLen: '25',
			validation: {
				required: {
					msg: 'Required!'
				}
			},
			type: 'text',
			nocHangeError: true,
			isMandatory: true,
			outLabel: true,
			errorOnBlur: true,
			inputHeight: '55px',
			lg: 5,
			xs: 12
		}
	],
	{
		name: 'notification',
		label: 'Please carry age proof for senior citizen verification !',
		required: true,
		type: 'notification',
		xs: 12,
		lg: 12
	},
	{
		name: 'identityProof',
		heading: 'Proof of Identity',
		required: true,
		bottomM: '3',
		type: 'label',
		xs: 12,
		lg: 12
	}
];

export const travellerForm2 = [
	[
		{
			name: 'govtIdType',
			label: 'Govt Id Type',
			validation: {},
			value: {
				name: 'Aadhar',
				description: 'Aadhar',
				id: 2,
				custom: {
					validator: validAadhar,
					msg: 'Enter valid Aadhar No'
				}
			},
			selectedValue: {
				name: 'Aadhar',
				description: 'Aadhar',
				id: 2,
				custom: {
					validator: validAadhar,
					msg: 'Enter valid Aadhar No'
				}
			},
			options: [
				{
					name: 'PAN',
					description: 'PAN',
					id: 1,
					custom: {
						validator: validPan,
						msg: 'Enter Valid PAN No'
					}
				},
				{
					name: 'Aadhar',
					description: 'Aadhar',
					id: 2,
					custom: {
						validator: validAadhar,
						msg: 'Enter valid Aadhar No'
					}
				},
				{
					name: 'PASSPORT',
					description: 'PASSPORT',
					id: 3,
					custom: {
						validator: validPassport,
						msg: 'Enter valid Passport No'
					}
				}
			],
			isOpenTop: true,
			type: 'select',
			outLabel: true,
			errorOnBlur: true,
			xs: 6,
			lg: 6
		},
		{
			name: 'govtIdNo',
			label: 'ID No',
			inputClass: 'greyTheme',
			value: '',
			maxLen: '25',
			validation: {
				required: {
					msg: ''
				}
			},
			type: 'text',
			nocHangeError: true,
			outLabel: true,
			errorOnBlur: true,
			inputHeight: '55px',
			xs: 6,
			lg: 6
		}]
];

export const travellerForm3 = [
	{
		name: 'preference',
		heading: 'Preferences',
		required: true,
		type: 'label',
		xs: 12,
		lg: 12
	},
	[
		{
			name: 'berthPref',
			label: 'Berth',
			required: true,
			validation: {
				required: {
					msg: 'Required!'
				}
			},
			options: [
				{
					name: 'Lower',
					description: 'Lower',
					id: 1
				},
				{
					name: 'Middle',
					description: 'Middle',
					id: 2
				},
				{
					name: 'Upper',
					description: 'Upper',
					id: 3
				}
			],
			isOpenTop: true,
			type: 'select',
			isMandatory: true,
			outLabel: true,
			errorOnBlur: true,
			xs: 6,
			lg: 6
		},
		{
			name: 'meal',
			label: 'meal',
			required: true,
			validation: {
				required: {
					msg: 'Required!'
				}
			},
			options: [
				{
					name: 'Vegetarian',
					description: 'Vegetarian',
					id: 1
				},
				{
					name: 'NonVegetarian',
					description: 'Non Vegetarian',
					id: 2
				}
			],
			isOpenTop: true,
			type: 'select',
			isMandatory: true,
			outLabel: true,
			errorOnBlur: true,
			xs: 6,
			lg: 6
		}]
];

export const travelDetailForm = [
	...travellerForm1,
	...travellerForm2,
	...travellerForm3
];

export const passengerDetailForm = {
	name: '',
	email: '',
	age: '',
	gender: '',
	nationality: '',
	govtIdType: {
		name: 'Aadhar',
		description: 'Aadhar',
		id: 2,
		custom: {
			validator: validAadhar,
			msg: 'Enter valid Aadhar No'
		}
	},
	govtIdNo: '',
	berthPref: '',
	meal: ''
};

export const cardViewMobileProps = {
	boxMargin: '0 auto 10px auto',
	boxPadding: '20px 10px',
	width: '95%'
};
